import toast from "react-hot-toast";

const notifyError = (message) => toast.error(message);
const notifySuccess = (message) => toast.success(message);

export { notifyError, notifySuccess };
